import { useEffect, useState } from "react";
import { getData } from "./Http/api";

const SujetoContactoTipo = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getData("/SujetoContactoTipoListar");

        const data = response.value.map((item) => ({
          idSujetoContactoTipo: item.idSujetoContactoTipo,
          descripcion: item.tipoContacto,
          activo: item.activo
        }));

        setRows(data);
      } catch (ex) {
        console.error("Error cargando Tipos de Contacto:", ex);
        setRows([]); // Devuelve array vacío si hay error
      }
    };

    fetchData();
  }, []);

  return rows;
};

// Named async helper for non-hook consumers
export const fetchSujetoContactoTipos = async () => {
  try {
    const response = await getData("/SujetoContactoTipoListar");
    return (response?.value || []).map((item) => ({
      idSujetoContactoTipo: item.idSujetoContactoTipo,
      descripcion: item.tipoContacto,
      activo: item.activo,
    }));
  } catch (ex) {
    console.error("Error cargando Tipos de Contacto (helper):", ex);
    return [];
  }
};

export default SujetoContactoTipo;
